import React, { Component } from 'react';
import './styles.scss';
import { getImage } from '../../utils';
import SearchBar from '../../CommonComponents/SearchBar';
import SearchIcon from '../../assets/icons/search.svg';
import DownArrow from '../../assets/icons/down_arrow.svg';
import CheckIcon from '../../assets/icons/check_new.svg';
import FilledArrow from '../../assets/icons/arrow_filled.svg';
import DatePicker from '../../CommonComponents/DatePicker';
import _moment, { Moment } from 'moment';
import { extendMoment } from 'moment-range';
import 'react-daterange-picker/dist/css/react-calendar.css';

type Props = {
  options: any[];
  selected: any;
  placeholder: string;
  onSelectionChange: Function;
  enddateSelection?: Function | any;
  filterType: 'external' | 'internal';
  searchBot?: string;
  fromAnalytics?: string;
  ranking?: string;
  // initialstartDate?:Moment;
  // initialendDate?:Moment;
  clearDateFilterValue?: boolean;
  endDate?: Moment | any;
  startDate?: Moment | any;
  notificationToaster?: Function;
};

type State = {
  isOpen: boolean;
  searchFilter: string;
  selectChat: string;
  // endDate: Moment;
  // startDate: Moment;
};

export default class Dropdown extends Component<Props, State> {
  // @ts-ignore
  moment = extendMoment(_moment);
  private myRef: React.RefObject<HTMLInputElement>;
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.searchText = this.searchText.bind(this);
    this.myRef = React.createRef();
  }

  setInitialState(): State {
    return {
      isOpen: false,
      searchFilter: '',
      selectChat: '',
      // startDate: this.moment().clone(),
      // endDate: this.moment().clone(),
    };
  }
  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  // shouldComponentUpdate(nextProps:Props, nextState:State) {
  //   if(nextProps.selected !== this.props.selected){
  //   return true;
  //   }
  //   else{
  //     return false;
  //   }
  // }

  handleClickOutside = (event: any) => {
    if (this.myRef.current && !this.myRef.current.contains(event.target)) {
      this.setState({
        isOpen: false,
      });
    }
  };

  toggleMenu() {
    this.setState((prevState) => ({
      isOpen: this.props.options.length ? !prevState.isOpen : false,
    }));
  }
  searchText(val: string) {
    this.setState({
      searchFilter: val,
    });
  }
  get option(): string[] {
    const searchTerm = this.state.searchFilter.toLowerCase();
    return this.props.options.filter(
      (option) => option.toLowerCase().indexOf(searchTerm) >= 0
    );
  }
  render() {
    // console.log('render')
    return (
      <div
        className='sf-dropdown-wrapper'
        ref={this.myRef}
        style={
          this.props.fromAnalytics === 'true' &&
          (this.props.placeholder === 'All queues' ||
            this.props.placeholder === 'All sources' ||
            this.props.placeholder === 'All agents')
            ? {
                width: '31.5%',
              }
            : this.props.placeholder === 'Environment'
            ? {
                paddingLeft: '0px',
                width: '89%',
                paddingTop: '15px',
                paddingBottom: '20px',
              }
            : {}
        }>
        <div
          className={this.props.selected === 'Ended chats' ? 'ended-chat-filter' : ''}
          style={
            this.props.selected === 'Ended chats' &&
            this.props.clearDateFilterValue === false
              ? {
                  border: 'unset',
                }
              : {
                  //  border: '1px solid rgba(0,0,0,0.2)',
                  borderRadius: '12px',
                }
          }>
          <div
            className={
              (this.props.selected ? 'selected' : 'placeholder') +
              ' clickable' +
              (this.props.filterType === 'external' ? ' ext' : '') +
              (this.props.fromAnalytics === 'true' ? ' from-analytics' : '') +
              (this.props.ranking === 'true' ? ' from-ranking' : '') +
              (this.props.selected === 'Ended chats' ? ' ended-chats-selected' : '') +
              (this.props.placeholder === 'Select bot to filter' ||
              this.props.placeholder === 'Select queue to filter'
                ? ' bot-queue-selected'
                : '')
            }
            onClick={() => {
              this.toggleMenu();
            }}
            style={
              this.props.placeholder === 'Select Nodes'
                ? {
                    fontWeight: 400,
                    padding: '8px',
                    color: 'black',
                    opacity: 1,
                    border: '1px solid rgba(0,0,0,0.2)',
                    //  borderRadius:'12px'
                  }
                : this.props.selected === 'Ended chats' &&
                  this.props.clearDateFilterValue === false
                ? {
                    fontWeight: 400,
                    borderTopRightRadius: 'unset',
                    borderBottomRightRadius: 'unset',
                    border: '1px solid rgba(0,0,0,0.2)',
                  }
                : this.props.selected === 'Ended chats'
                ? { border: 'unset' }
                : this.props.placeholder === 'Environment'
                ? {
                    height: '20px',
                    fontWeight: 400,
                    borderRadius: '5px',
                    border: '1px solid rgba(0,0,0,0.2)',
                  }
                : { fontWeight: 400, border: '1px solid rgba(0,0,0,0.2' }
            }>
            {this.props.selected === '' || this.props.selected === 'string'
              ? this.props.placeholder
              : this.props.selected}
            {this.props.options.length ? (
              <img
                src={
                  this.props.fromAnalytics || this.props.placeholder === 'Environment'
                    ? DownArrow
                    : this.props.placeholder === 'Select Nodes' ||
                      this.props.selected === 'Ended chats' ||
                      this.props.selected === 'Ongoing chats'
                    ? FilledArrow
                    : getImage(`dropdown-arrow${this.props.selected ? '-white' : ''}.svg`)
                }
                alt='dropdown'
                style={{ transform: this.state.isOpen ? 'rotate(180deg)' : '' }}
              />
            ) : null}
          </div>
          {this.props.selected === 'Ended chats' ? (
            <div
              className='ended-chat-filter-image'
              style={{
                width: '15%',
                //  cursor:'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderLeft: '1px solid rgba(0,0,0,0.2)',
                borderTopRightRadius: '12px',
                borderBottomRightRadius: '12px',
              }}>
              <DatePicker
                onDateSelection={(start: Moment, end: Moment, selected: any) => {
                  this.props.enddateSelection(start, end, selected);
                }}
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                dateFilter='true'
                clearDateFilterValue={this.props.clearDateFilterValue}
                notificationToaster={this.props.notificationToaster}
              />
            </div>
          ) : null}
        </div>

        {this.props.selected && this.props.filterType !== 'external' ? (
          <div
            id='clear'
            className='clickable'
            onClick={() => {
              this.props.onSelectionChange('');
            }}>
            Clear filter
          </div>
        ) : null}
        <div
          id='menu'
          style={
            this.props.ranking === 'true'
              ? { display: this.state.isOpen ? 'block' : 'none', top: '49px' }
              : this.props.placeholder === 'Select Nodes'
              ? { display: this.state.isOpen ? 'block' : 'none', height: '228px' }
              : this.props.placeholder === 'Environment'
              ? { display: this.state.isOpen ? 'block' : 'none', maxHeight: '30vh' }
              : { display: this.state.isOpen ? 'block' : 'none' }
          }>
          {(this.props.searchBot === 'yes' ||
            this.props.placeholder === 'Select agent' ||
            this.props.placeholder === 'Select one' ||
            this.props.placeholder === 'Select Queue' ||
            this.props.placeholder === 'All queues' ||
            this.props.placeholder === 'All agents' ||
            this.props.placeholder === 'Select Nodes') && (
            <SearchBar
              placeholder={
                this.props.placeholder === 'Select agent' ||
                this.props.placeholder === 'All agents'
                  ? 'Search Agents'
                  : this.props.placeholder === 'Select one'
                  ? 'Select one'
                  : this.props.placeholder === 'Select Queue' ||
                    this.props.placeholder === 'All queues' ||
                    this.props.placeholder === 'Select queue to filter'
                  ? 'Search Queue'
                  : this.props.placeholder === 'Select Nodes'
                  ? 'Search nodes'
                  : 'Search bots'
              }
              icon={SearchIcon}
              importedImg={
                this.props.placeholder === 'Select agent' ||
                this.props.placeholder === 'All agents' ||
                this.props.placeholder === 'Select one' ||
                this.props.placeholder === 'Select Queue' ||
                this.props.placeholder === 'All queues' ||
                this.props.placeholder === 'Select Nodes'
                  ? 'yes'
                  : this.props.searchBot
              }
              serchText={this.searchText}
            />
          )}
          {this.option.map((option, index) => {
            let optionVal: any = null;
            let slicedVal: any = option.replace(/GS/g, '').replace(/_M/g, '');
            this.props.placeholder === 'Select bot to filter' ||
            this.props.placeholder === 'Select queue to filter'
              ? (optionVal = slicedVal.charAt(0).toUpperCase() + slicedVal.slice(1))
              : (optionVal = index);

            return (
              <div
                key={index}
                className='clickable'
                onClick={() => {
                  this.props.placeholder === 'Select Nodes'
                    ? this.props.onSelectionChange(option)
                    : this.props.onSelectionChange(optionVal);
                  this.toggleMenu();
                }}
                style={
                  this.props.placeholder === 'Select Nodes'
                    ? {
                        display: 'flex',
                        justifyContent: 'space-between',
                        color: 'rgba(0, 0, 0)',
                        opacity: 1,
                      }
                    : this.props.placeholder === 'Environment'
                    ? { margin: '9px 12px' }
                    : this.props.selected !== ''
                    ? { display: 'flex', justifyContent: 'space-between' }
                    : {}
                }>
                {this.props.placeholder === 'Select bot to filter'
                  ? optionVal.charAt(0).toUpperCase() + optionVal.slice(1)
                  : this.props.placeholder === 'Select queue to filter'
                  ? optionVal.charAt(0).toUpperCase() + optionVal.slice(1)
                  : this.props.placeholder === 'Select Queue' ||
                    this.props.placeholder === 'All queues'
                  ? slicedVal.charAt(0).toUpperCase() + slicedVal.slice(1)
                  : option}
                {this.props.selected === option ? (
                  <img alt='checkIcon' src={CheckIcon} />
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
